/**
 * Maps sanitized post style objects to CSS classes and inline custom properties.
 * Mirrors server/server/utils/style-sanitize.js styleToRenderTokens().
 */

import { resolveStyleColors } from './post-style-contrast.js';

const STYLE_FONTS = {
  arial: 'Arial, Helvetica Neue, Helvetica, sans-serif',
  georgia: 'Georgia, Times New Roman, serif',
  courier: 'Courier New, Courier, monospace',
  comic: 'Comic Sans MS, Comic Sans, cursive',
  trebuchet: 'Trebuchet MS, Helvetica, sans-serif',
  verdana: 'Verdana, Geneva, sans-serif',
  impact: 'Impact, Haettenschweiler, Arial Narrow Bold, sans-serif',
  palatino: 'Palatino Linotype, Palatino, serif'
};

const STYLE_FONT_SIZES = {
  small: '0.875rem',
  normal: '1rem',
  large: '1.25rem'
};

const STYLE_BORDERS = {
  none: '',
  soft: 'post-border-soft',
  dashed: 'post-border-dashed',
  neon: 'post-border-neon',
  retro: 'post-border-retro'
};

export const POST_STYLE_TOKEN_CLASSES = [
  'post-styled',
  'post-style-retro-terminal',
  'post-style-pastel-dreams',
  'post-style-neon-nights',
  'post-style-fourth-of-july',
  'post-font-arial',
  'post-font-georgia',
  'post-font-courier',
  'post-font-comic',
  'post-font-trebuchet',
  'post-font-verdana',
  'post-font-impact',
  'post-font-palatino',
  'post-size-small',
  'post-size-normal',
  'post-size-large',
  'post-border-soft',
  'post-border-dashed',
  'post-border-neon',
  'post-border-retro'
];

export function styleToRenderTokens(style) {
  if (!style || typeof style !== 'object') {
    return { classes: [], cssVars: {}, inlineStyle: '' };
  }

  const classes = ['post-styled'];
  if (style.preset) classes.push(`post-style-${style.preset}`);
  if (style.font) classes.push(`post-font-${style.font}`);
  if (style.fontSize) classes.push(`post-size-${style.fontSize}`);
  if (style.border && style.border !== 'none' && STYLE_BORDERS[style.border]) {
    classes.push(STYLE_BORDERS[style.border]);
  }

  const { fgColor, bgColor } = resolveStyleColors(style);
  const cssVars = {};
  if (style.fgColor || style.preset) cssVars['--post-fg'] = fgColor;
  if (style.bgColor || style.preset) cssVars['--post-bg'] = bgColor;
  if (style.font && STYLE_FONTS[style.font]) {
    cssVars['--post-font-family'] = STYLE_FONTS[style.font];
  }
  if (style.fontSize && STYLE_FONT_SIZES[style.fontSize]) {
    cssVars['--post-font-size'] = STYLE_FONT_SIZES[style.fontSize];
  }

  const inlineStyle = Object.entries(cssVars)
    .map(([key, val]) => `${key}: ${val}`)
    .join('; ');

  return { classes, cssVars, inlineStyle };
}
